// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".address__content{margin-bottom:6px}.county{margin:0 0 14px 0}.county__subhead{font-weight:400;font-style:italic;display:block;color:var(--color-display)}", ""]);
// Exports
module.exports = exports;
